var _style, _g, _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvolutionLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-100 0 1000 760",
    style: {
      enableBackground: "new 0 0 720 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000108283386483407122700000004757170984316117377_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.8,452.5h38v-13.5H49.5c-3.9,0-7.1,3.2-7.1,7.1v51.4c0,3.9,3.2,7.1,7.1,7.1h51.3v-11.9H63 c-1.4,0-2.6-1.1-2.6-2.6v-9.3c0-1.4,1.2-2.6,2.6-2.6h14.5l7.4-13.4H62.9c-1.3,0-2.4-1.1-2.4-2.4v-7.6 C60.5,453.6,61.6,452.5,62.8,452.5L62.8,452.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "159.6,504.7 187.7,439.1 168,439.1 149,489.5 129.9,439.1 110.2,439.1 138.4,504.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.3,439.1h-50.1c-5.5,0-10,4.5-10,10v45.6c0,5.5,4.5,10,10,10h50.1c5.5,0,10-4.5,10-10v-45.6 C262.3,443.6,257.8,439.1,252.3,439.1z M244.4,492.3h-35.2v-40.6h35.2V492.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.8,439.1h-50.1c-5.5,0-10,4.5-10,10v45.6c0,5.5,4.5,10,10,10h50.1c5.5,0,10-4.5,10-10v-45.6 C596.8,443.6,592.3,439.1,586.8,439.1z M578.9,492.3h-35.2v-40.6h35.2V492.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.8,492.3v-53.2h-17.9v55.3c0,5.7,4.6,10.3,10.3,10.3h48.4v-12.4L289.8,492.3L289.8,492.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.9,439.1v53.2h-35v-53.2h-18.3v54.8c0,5.9,4.8,10.8,10.8,10.8H401c5.9,0,10.8-4.8,10.8-10.8v-54.8H393.9 L393.9,439.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M624.3,504.7v-53.2h35v53.2h18.3v-54.8c0-5.9-4.8-10.8-10.8-10.8h-49.7c-5.9,0-10.8,4.8-10.8,10.8v54.8H624.3 L624.3,504.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "445.1,451.7 445.1,504.7 461.7,504.7 461.7,451.7 485.7,451.7 485.7,439.1 422.2,439.1 422.2,451.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496.6,
    y: 439.1,
    className: "st0",
    width: 18.1,
    height: 65.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.9,400.5h109c2.1-6.6,4-13.2,5.9-19.8C264.4,393.5,225.6,400.5,184.9,400.5L184.9,400.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.7,317.2c-5.1,28.2-11.8,56-20.2,83.3h62.7c18.2-64.6,27.9-131.3,29.1-199.3 C464.1,245.3,439,285,404.7,317.2L404.7,317.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.7,373.6c-2.4,9-4.9,18-7.7,26.9h58.3c6.9-22.1,12.8-44.5,17.5-67.2C365.5,349.3,342.6,362.9,317.7,373.6 L317.7,373.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -713.3,
    cy: -519.4,
    r: 455.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolutionLogo);
export default __webpack_public_path__ + "static/media/evolution-logo.f66a98bacdb659d4d6ec3629a90cc4d0.svg";
export { ForwardRef as ReactComponent };